import { render } from "./expensesHistoryModal.vue?vue&type=template&id=2ef78d74&scoped=true"
import script from "./expensesHistoryModal.vue?vue&type=script&lang=js"
export * from "./expensesHistoryModal.vue?vue&type=script&lang=js"

import "./expensesHistoryModal.vue?vue&type=style&index=0&id=2ef78d74&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef78d74"]])

export default __exports__